import { FC, useMemo } from 'react'

import { Link } from '@mui/material'

import { GRTooltip } from '../../../../../components/GRTooltip/GRTooltip'
import { Magnify } from '../../../../../components/Magnify/Magnify'
import { getAnalysisCommentEditPath } from '../../helpers/reviewHelpers'
import { useReviewTooltip } from '../../hooks/useReviewTooltip'
import { ReviewStatus } from '../../types/ReviewStatus'
import { ReviewStatusIcon } from '../ReviewStatusIcon/ReviewStatusIcon'

type CommentStatusIndicatorProps = {
  analysis: { gameId: string; gameVersion?: string | null; commentId?: string | null; commentPublished?: boolean }
}

export const CommentStatusIndicator: FC<CommentStatusIndicatorProps> = ({ analysis }) => {
  const status = useMemo(() => {
    if (!analysis.commentId) {
      return ReviewStatus.Empty
    } else if (analysis.commentPublished) {
      return ReviewStatus.Published
    } else {
      return ReviewStatus.Draft
    }
  }, [analysis.commentId, analysis.commentPublished])

  const tooltip = useReviewTooltip(status)

  return (
    <GRTooltip content={tooltip}>
      <Link href={getAnalysisCommentEditPath(analysis)} target="_blank" rel="noopener noreferrer" aria-label={tooltip}>
        <Magnify force>
          <ReviewStatusIcon status={status} />
        </Magnify>
      </Link>
    </GRTooltip>
  )
}
